(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  class BlogArticleEnhancements {
    constructor(root) {
      this.root = root;
      this.links = Array.from(root.querySelectorAll('.article-toc--sidebar .article-toc__link'));
      this.initScrollSpy();
      this.initCopyLink();
      this.initMobileToc();
    }

    // The mobile TOC ships collapsed. Once a reader picks a section, close it
    // again so the heading they jumped to is what fills the screen.
    initMobileToc() {
      const details = this.root.querySelector('.article-toc--mobile');
      if (!details) return;

      details.addEventListener('click', (event) => {
        const link = event.target.closest('.article-toc__link');
        if (link) details.open = false;
      });
    }

    initScrollSpy() {
      if (this.links.length === 0 || !('IntersectionObserver' in window)) return;

      const byId = new Map();
      const targets = [];

      this.links.forEach((link) => {
        const id = link.dataset.tocTarget;
        const heading = id ? document.getElementById(id) : null;
        if (!heading) return;
        byId.set(heading, link);
        targets.push(heading);
      });

      if (targets.length === 0) return;

      const visible = new Set();

      const setActive = () => {
        let current = null;
        for (const heading of targets) {
          if (visible.has(heading)) {
            current = heading;
            break;
          }
          if (heading.getBoundingClientRect().top < 120) current = heading;
        }
        this.links.forEach((link) => link.removeAttribute('aria-current'));
        if (current && byId.has(current)) {
          const link = byId.get(current);
          link.setAttribute('aria-current', 'true');
          // Only the TOC list scrolls — never the whole sidebar column.
          const list = link.closest('.article-toc__list');
          if (list && list.scrollHeight > list.clientHeight) {
            const linkTop = link.offsetTop - list.offsetTop;
            if (linkTop < list.scrollTop || linkTop > list.scrollTop + list.clientHeight - 40) {
              list.scrollTo({ top: linkTop - 40, behavior: 'smooth' });
            }
          }
        }
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          setActive();
        },
        { rootMargin: '-100px 0px -70% 0px', threshold: 0 }
      );

      targets.forEach((heading) => observer.observe(heading));
      setActive();
    }

    initCopyLink() {
      const button = this.root.querySelector('.article-share__copy');
      if (!button || !navigator.clipboard) return;

      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.copyLink);
          button.dataset.copied = 'true';
          button.setAttribute('aria-label', 'Link copied');
          setTimeout(() => {
            delete button.dataset.copied;
            button.setAttribute('aria-label', 'Copy link');
          }, 2000);
        } catch (error) {
          // Clipboard blocked (insecure context or denied permission) — leave the UI untouched.
        }
      });
    }
  }

  document.querySelectorAll('.blog-article').forEach((root) => new BlogArticleEnhancements(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
